import React, { useState, useEffect } from 'react';
import {Button, mergeClasses} from "@fluentui/react-components";
import {useStyles} from "../../../../styles/mission/ver1";

interface OtherMissionBtnProps {
    onClick: () => void;
    className?: string;
    style?: React.CSSProperties;
}

export default function OtherMissionBtn({  onClick, className, style }: OtherMissionBtnProps) {
    const styles = useStyles();
    const [isDisabled, setIsDisabled] = useState(false);
    const [countdown, setCountdown] = useState(5);

    const handleClick = () => {
        setIsDisabled(true)
        setCountdown(10)
        setTimeout(()=>{
            onClick()
        },500)
    };

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (isDisabled && countdown > 0) {
            timer = setInterval(() => {
                setCountdown((prev) => prev - 1)
            }, 1000);
        }

        if (countdown === 0) {
            setIsDisabled(false)
            setCountdown(5)
        }

        return () => {
            if (timer) {
                clearInterval(timer)
            }
        };
    }, [isDisabled, countdown])

    // localStorage를 사용하여 새로고침 후에도 타이머 상태 유지
    useEffect(() => {
        const disabledUntil = localStorage.getItem('buttonDisabledUntil')
        if (disabledUntil) {
            const timeLeft = Math.ceil((parseInt(disabledUntil) - Date.now()) / 1000)
            if (timeLeft > 0) {
                setIsDisabled(true)
                setCountdown(timeLeft)
            } else {
                localStorage.removeItem('buttonDisabledUntil')
            }
        }
    }, []);

    useEffect(() => {
        if (isDisabled) {
            const disabledUntil = Date.now() + countdown * 1000
            localStorage.setItem('buttonDisabledUntil', disabledUntil.toString())
        }
    }, [isDisabled, countdown])

    return (
        <Button
            onClick={handleClick}
            disabled={isDisabled}
            className={mergeClasses(styles.roundedBtn, styles.outlinedBtn, className)}
            style={style}
        >
            {isDisabled ? `다른 미션 가져오기 (${countdown}초)` : '다른 미션 가져오기'}
        </Button>
    );
}